import { useContext } from "react";
import { AppContext } from "./AppContext";
import ColorIcon from "./ColorIcon";
import { icons } from "./icons";

export default function CustomBg() {
  const { customBg, setCustomBg, bg } = useContext(AppContext);
  const color = customBg || bg;
  const icon = customBg && (
    <div
      onClick={() => setCustomBg(false)}
      className="flexer absolute -left-3 top-1/2 z-50 -mt-2 h-4 w-4 cursor-pointer rounded-full bg-dark-800 text-white ring-1 ring-white dark:bg-white dark:text-dark-800 dark:ring-dark-900"
    >
      <div className="scale-50">{icons.close}</div>
    </div>
  );
  return (
    <>
      <div className="miniLabel">Bg</div>
      <div className="relative">
        {icon}
        <ColorIcon value={color} isCustomBg={true} />
      </div>
    </>
  );
}
